import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { isAdminDomain, isPartnerDomain, isSupportDomain } from '../currentDomain'

export const SFormHeader = styled.h1<{ inverted?: boolean }>`
    margin: 0;
    padding: 0;
    text-align: center;
    font-family: 'Lateral Extended', sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: ${({ inverted }) => (!inverted ? '#000' : '#fff')};

    b {
        font-family: 'Lateral Extended', sans-serif;
        font-weight: 500;
    }
`
const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`

export type FormHeaderProps = {
    inverted?: boolean
    className?: ClassName
    style?: React.CSSProperties
}

export function FormHeader({ inverted, className, style }: FormHeaderProps): React.ReactElement {
    return (
        <SFormHeader className={cn(className)} style={style} data-testid="formHeader" inverted={inverted}>
            {isAdminDomain ? (
                <>
                    Charging <b>Admin</b>
                </>
            ) : isPartnerDomain ? (
                <>
                    Charging <b>Partner</b>
                </>
            ) : isSupportDomain ? (
                <Container>
                    <div data-testid="Charging">Charging</div>
                    <b data-testid="Support">Support</b>
                </Container>
            ) : (
                <b>MyChargeSpace</b>
            )}
        </SFormHeader>
    )
}
